export const LOGO_WIDTH = 1024
export const LOGO_HEIGHT = 500
export const SPLASH_WIDTH = 750
export const SPLASH_HEIGHT = 1334
export const DEFAULT_LOGO_FILE = 'defaultLogo.jpg'
export const DEFAULT_SPLASH_SCREEN_FILE = 'defaultSplashScreen.jpg'
export const BRAND_PROFILE_WIDTH = 360
export const BRAND_PROFILE_HEIGHT = 360
